import ExcelJS from "exceljs";

export default class DetalleTicketPromedioExcel {
  static generateWorkbook(groupedDetalleVenta) {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("DetalleVenta");

    // titulo
    sheet.mergeCells("A1:D1");
    const title = sheet.getCell("A1");
    title.value = "Detalles de Venta";
    title.font = { bold: true, size: 16 };
    title.alignment = { horizontal: "center", vertical: "middle" };
    title.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD3D3D3" },
    };

    // estadísticas generales con estilo visual
    const stats = [
      `Total General: $ ${groupedDetalleVenta.grandTotal}`,
      `Total de tickets: ${groupedDetalleVenta.tickets}`,
      `Total de comensales: ${groupedDetalleVenta.comensales}`,
      `Promedio por ticket: $ ${groupedDetalleVenta.averageTicket}`,
      `Promedio por comensal: $ ${groupedDetalleVenta.averagePerComensal}`,
    ];

    stats.forEach((text, idx) => {
      const rowNum = 2 + idx;
      // merge de A–D para el texto completo
      sheet.mergeCells(`A${rowNum}:D${rowNum}`);

      // celda maestra
      const master = sheet.getCell(`A${rowNum}`);
      master.value = text;
      master.font = { bold: true, size: 12 };
      master.alignment = { horizontal: "center", vertical: "middle" };
      // ajustar altura para más espacio
      sheet.getRow(rowNum).height = 25;

      // aplicamos borde a cada celda de A a D
      for (let col = 1; col <= 4; col++) {
        const cell = sheet.getRow(rowNum).getCell(col);
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      }
    });

    // salto de linea
    let currentRow = 8;

    // detalle por grupo (folio)
    groupedDetalleVenta.groups.forEach((group) => {
      // encabezado de folio
      sheet.mergeCells(`A${currentRow}:D${currentRow}`);
      const hdr = sheet.getCell(`A${currentRow}`);
      hdr.value = `Folio ${group.folio} — Total: $ ${group.total} — Comensales: ${group.comensales}`;
      hdr.font = { bold: true };
      hdr.alignment = { horizontal: "center", vertical: "middle" };
      hdr.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFEEEEEE" },
      };
      currentRow++;

      // sub-encabezado fecha/cliente (centrado)
      sheet.mergeCells(`A${currentRow}:D${currentRow}`);
      const subHdr = sheet.getCell(`A${currentRow}`);
      subHdr.value = `Fecha: ${group.fecha} — Cliente: ${group.cliente}`;
      subHdr.font = { italic: true };
      subHdr.alignment = { horizontal: "center", vertical: "middle" };
      // borde alrededor del subencabezado
      for (let col = 1; col <= 4; col++) {
        sheet.getRow(currentRow).getCell(col).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      }
      currentRow++;

      // fila de encabezados de productos
      const headerRow = sheet.getRow(currentRow);
      headerRow.values = ["Cantidad", "Nombre", "Precio", "Moneda"];
      headerRow.font = { bold: true };
      headerRow.alignment = { horizontal: "center", vertical: "middle" };
      // borde de encabezados
      for (let col = 1; col <= 4; col++) {
        headerRow.getCell(col).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      }
      currentRow++;

      // filas de items
      group.items.forEach((item) => {
        const row = sheet.getRow(currentRow);
        row.values = [item.Cantidad, item.Nombre, item.Precio, item.Moneda];
        // formato numerico al precio
        row.getCell(3).numFmt = "#,##0.00";
        // destacar el producto principal
        if (item.isPrincipal) {
          [1, 2, 3, 4].forEach((colIdx) => {
            row.getCell(colIdx).fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFBBDEFB" },
            };
          });
        }
        // borde de celdas de datos
        [1, 2, 3, 4].forEach((colIdx) => {
          row.getCell(colIdx).border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
        currentRow++;
      });

      // espacio antes del siguiente grupo
      currentRow++;
    });

    // definir y autoajustar anchos de columna
    sheet.columns = [
      { key: "cantidad", width: 12 },
      { key: "nombre", width: 30 },
      { key: "precio", width: 15, numFmt: "#,##0.00" },
      { key: "moneda", width: 10 },
    ];
    sheet.columns.forEach((col) => {
      let maxLen = col.width || 10;
      col.eachCell({ includeEmpty: true }, (cell) => {
        const txt = cell.value ? cell.value.toString() : "";
        if (txt.length > maxLen) maxLen = txt.length;
      });
      col.width = maxLen + 2;
    });

    return workbook;
  }

  static async generateExcelBuffer(groupedDetalleVenta) {
    const wb = DetalleTicketPromedioExcel.generateWorkbook(groupedDetalleVenta);
    return await wb.xlsx.writeBuffer();
  }
}
